import { useLayoutEffect as reactUseLayoutEffect } from "react";

// eslint-disable-next-line
export const useLayoutEffect = globalThis?.document ? reactUseLayoutEffect : () => {};
